import { categories } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20composition%20with%20colorful%20fashion%20accessories%20scarves%20watches%20sunglasses%20and%20leather%20goods%20scattered%20on%20light%20warm%20terracotta%20surface%2C%20soft%20morning%20sunlight%20casting%20gentle%20shadows%2C%20editorial%20photography%20with%20rich%20textures%20and%20organic%20arrangement%2C%20elevated%20lifestyle%20aesthetic%20with%20negative%20space&width=1800&height=1200&seq=hero-main-v3-001&orientation=landscape"
        alt="Litbuy Spreadsheet fashion products background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center pt-16">
        <span className="inline-block px-5 py-2 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm text-white text-xs md:text-sm font-medium tracking-wider mb-6 md:mb-8">
          SEO Tools for E-Commerce Sellers
        </span>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-semibold text-white leading-tight max-w-4xl">
          Litbuy Spreadsheet
          <br />
          <span className="font-heading italic font-normal">Your Growth Engine</span>
        </h1>

        <p className="mt-5 md:mt-6 text-sm md:text-base text-white/80 max-w-xl leading-relaxed">
          Modern tools for modern sellers. Drive premium traffic, organize your inventory, and scale your e-commerce business with data-driven spreadsheet solutions.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4 mt-8 md:mt-10">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 hover:scale-105"
          >
            Litbuy Spreadsheet
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-white/90 text-foreground-900 font-semibold text-sm md:text-base hover:bg-white transition-all duration-300 hover:scale-105 backdrop-blur-sm"
          >
            Buy It Now
            <i className="ri-shopping-bag-3-line"></i>
          </a>
        </div>

        <div className="mt-12 md:mt-16 w-full max-w-3xl">
          <p className="text-white/60 text-xs md:text-sm mb-4 font-medium tracking-wider uppercase">Browse Product Categories</p>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3">
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="whitespace-nowrap cursor-pointer inline-block px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs md:text-sm hover:bg-white/20 transition-all duration-300 hover:scale-105"
              >
                {cat.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}